import React from 'react'
import { Route, IndexRoute } from 'react-router'

import App from './containers/app'
import EmailSignUpPage from './containers/pages/email-sign-up-page/email-sign-up-page'
import SignInPage from './containers/pages/sign-in-page/sign-in-page'
import SignUpPage from './containers/pages/sign-up-page/sign-up-page'
import SignOutPage from './containers/pages/sign-out-page/sign-out-page'
import ForgotPasswordPage from './containers/pages/forgot-password-page/forgot-password-page'
import UpdatePasswordPage from './containers/pages/update-password-page/update-password-page'
import AccountDetailsPage from './containers/pages/account-details-page/account-details-page'
import GPWebPlansPage from './containers/pages/gp-web-plans/gp-web-plans-page'
import GPWebPlansCheckoutPage from './containers/pages/gp-web-plans-checkout/gp-web-plans-checkout-page'
import Error404Page from './containers/pages/error-404-page/error-404-page'
import Error500Page from './containers/pages/error-500-page/error-500-page'
import GPWebUpdatePasswordPage from './containers/pages/gp-web-update-password-page/gp-web-update-password-page'
import GPWebForgotPasswordPage from "./containers/pages/gp-web-forgot-password-page/gp-web-forgot-password-page";
import GPWebSigninPage from "./containers/pages/gp-web-login-page/gp-web-signin-page";
import GPWebPlansThankYouPage from './containers/pages/gp-web-plans-thank-you-page/gp-web-plans-thank-you-page'

export default (
  <Route component={App} path="/">
    <IndexRoute component={SignUpPage} />
    <Route path="gp-web">
      <Route path="emailsignup" component={EmailSignUpPage} />
      <Route path="signup" component={SignUpPage} />
      <Route path="signin" component={GPWebSigninPage} />
      <Route path="forgotpwd" component={GPWebForgotPasswordPage} />
      <Route path="update-password" component={GPWebUpdatePasswordPage} />
      <Route path="forgot-password" component={GPWebForgotPasswordPage} />
      <Route path="plans" component={GPWebPlansPage} />
      <Route path="plans-checkout" component={GPWebPlansCheckoutPage} />
      <Route path="plans-thank-you/:email/:price/:currency" component={GPWebPlansThankYouPage} />
    </Route>
    <Route path="emailsignup" component={EmailSignUpPage} />
    <Route path="signup" component={SignUpPage} />
    <Route path="signin" component={SignInPage} />
    <Route path="signout" component={SignOutPage} />
    <Route path="forgotpwd" component={ForgotPasswordPage} />
    <Route path="update-password" component={UpdatePasswordPage} />
    <Route path="accountdetails" component={AccountDetailsPage} />
    <Route path="error404" component={Error404Page} />
    <Route path="error500" component={Error500Page} />
  </Route>
)



// WEBPACK FOOTER //
// ./src/routes.js